module.exports = __webpack_public_path__ + "static/media/fileNameIconDark.91d62090.png";